var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneForwarded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.318 11.3L38.5676 3.72C37.9133 3.08 36.809 3.52 36.809 4.42V8H29.6517C29.0791 8 28.6292 8.44 28.6292 9V15C28.6292 15.56 29.0791 16 29.6517 16H36.809V19.58C36.809 20.48 37.9133 20.92 38.5472 20.28L46.2975 12.7C46.7065 12.32 46.7065 11.68 46.318 11.3ZM39.3243 30.52L34.1301 29.94C32.8827 29.8 31.6557 30.22 30.7764 31.08L27.0137 34.76C21.2265 31.88 16.4822 27.26 13.5375 21.58L17.3207 17.88C18.2 17.02 18.6294 15.82 18.4863 14.6L17.8933 9.56C17.6479 7.54 15.9097 6.02 13.8238 6.02H10.2861C7.97527 6.02 6.05303 7.9 6.19617 10.16C7.27999 27.24 21.247 40.88 38.6903 41.94C41.0011 42.08 42.9234 40.2 42.9234 37.94V34.48C42.9438 32.46 41.3897 30.76 39.3243 30.52Z",
    fill: "#FF0056"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneForwarded);
export default __webpack_public_path__ + "static/media/phoneForwarded.817dd289492cb6c374c96feda514c496.svg";
export { ForwardRef as ReactComponent };